class AIChatManager {
	constructor() {
		this.isLoading = false;
		this.currentProducts = [];
		this.userEmail = null; // Store user's email for the session
		this.initialize();
	}

	initialize() {
		this.userId = web.visitor.id;
		this.sessionId = this.new_session_id();

		const sidenav = $('#ai-chat-sidenav');
		const overlay = $('#ai-chat-overlay');
		const closeBtn = $('#close-chat');
		const chatInput = $('#chat-input');
		const newChatBtn = $('#new-chat-btn');
		const sendBtn = $('#send-btn');

		chatInput.on('keypress', (e) => {
			if (e.which === 13 && !e.shiftKey) {
				e.preventDefault();
				this.sendMessage();
			}
		});

		sendBtn.on('click', () => this.sendMessage());

		// New chat button event
		newChatBtn.on('click', () => this.startNewChat());

		// Use event delegation for dynamically created email buttons
		$(document).on('click', '.send-email-button', (event) => this.sendEmail(event));

		// Close button events
		closeBtn.on('click', () => this.closeSidenav());
		overlay.on('click', () => this.closeSidenav());

		// Escape key to close
		$(document).on('keydown', (e) => {
			if (e.which === 27 && sidenav.hasClass('open')) { // Escape key
				this.closeSidenav();
			}
		});
	}

	async loadChatHistory() {
		try {
			const response = await fetch('/functions/n8n.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action: 'get_chat_history',
					user_id: this.userId
				})
			});

			const result = await response.json();
			if (result.success && result.history.length > 0) {
				const messagesContainer = $('#chat-messages');
				messagesContainer.empty();

				result.history.forEach((chat, index) => {
					// Extract user email from any message in the session history
					if (chat.user_email && !this.userEmail) {
						this.userEmail = chat.user_email;
					}

					const messageId = chat.message_id;
					this.addUserMessage(messageId, chat.user_message, false);
					if (chat.ai_response && chat.ai_response.response) {
						const sell_rent = chat.ai_response.response.sell_rent || null;
						const no_results = chat.ai_response.response.no_results || null;
						if (sell_rent) {
							this.addAISellRentMessage(messageId);
						}
						else if (no_results) {
							const responseText = chat.ai_response.response.text || web.labels.no_results_found;
							this.addAINoResultMessage(messageId);
						}
						else {
							const responseText = chat.ai_response.response.text || chat.ai_response.response.output || null;
							const displayedProducts = chat.ai_response.response.displayed_products || [];
							const allProducts = chat.ai_response.response.products || [];
							const isEmailSent = chat.is_email_sent ? true : false;
							const userEmail = chat.user_email || null;
							this.addAIMessage(messageId, responseText, displayedProducts, allProducts, isEmailSent, userEmail);
						}
					}
				});

				// Scroll to bottom after loading history
				this.scrollToBottom();
			}
		} catch (error) {
			console.error('Chat history load error:', error);
		}
	}

	async sendMessage() {
		const chatInput = $('#chat-input');
		const message = chatInput.val().trim();

		if (!message || this.isLoading) return;

		// Generate unique message ID for this interaction

		this.addUserMessage(0, message);
		chatInput.val('');

		this.setLoading(true);

		try {
			const response = await fetch('/functions/n8n.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action: 'chat',
					message: message,
					user_id: this.userId,
					session_id: this.sessionId,
				})
			});

			const result = await response.json();
			const messageId = result.message_id || null;

			if (result.success && result.response) {
				const sell_rent = result.response.sell_rent || null;
				const no_results = result.response.no_results || null;
				if (sell_rent) {
					this.addAISellRentMessage(messageId);
				}
				else if (no_results) {
					const responseText = result.response.text || "";
					const searchCriteria = result.response.no_results_criteria || "";
					this.addAINoResultMessage(messageId, responseText, searchCriteria, true);
				}
				else {
					const responseText = result.response.text || null;
					const allProducts = result.response.products || [];
					const displayedProducts = result.response.displayed_products || [];
					this.addAIMessage(messageId, responseText, displayedProducts, allProducts);
				}
			} else {
				this.addAIMessage(messageId, web.labels.operation_not_completed, [], []);
			}
		} catch (error) {
			this.addAIMessage(0, web.labels.operation_not_completed, [], []);
		} finally {
			this.setLoading(false);
		}
	}

	addLoadingMessage() {
		const messagesContainer = $('#chat-messages');
		const loadingHtml = `
			<div class="chat-message ai-message mb-3 loading-message">
				<div class="d-flex align-items-start">
					<div class="avatar rounded-circle d-flex align-items-center justify-content-center me-2">
						<i class="icon space-ai ripple large" style='border-radius: 50%;'></i>
					</div>
				</div>
			</div>
		`;
		messagesContainer.append(loadingHtml);
		this.scrollToBottom();
	}

	removeLoadingMessage() {
		$('.loading-message').remove();
	}

	addAINoResultMessage(messageId, aiMessage = "", searchCriteria = "", displayForm = false) {
		const messagesContainer = $('#chat-messages');
		const timestamp = new Date().toLocaleTimeString('tr-TR', {
			hour: '2-digit',
			minute: '2-digit'
		});

		// Extract only the first sentence from searchCriteria
		const firstSentence = searchCriteria.split(/[.!?]+/)[0].trim();

		// Multilingual labels
		const labels = {
			noResults: web.current_language_code === 'en'
				? "Sorry, no results found for your search criteria. Please leave your contact information so our experts can help you."
				: "Üzgünüm, arama kriterlerinize uygun sonuç bulunamadı. Lütfen iletişim bilgilerinizi bırakın, uzmanlarımız size yardımcı olsun.",
			firstName: web.current_language_code === 'en' ? "First Name" : "Ad",
			lastName: web.current_language_code === 'en' ? "Last Name" : "Soyad",
			email: web.current_language_code === 'en' ? "Email" : "E-posta",
			phone: web.current_language_code === 'en' ? "Phone" : "Telefon",
			message: web.current_language_code === 'en' ? "Message" : "Mesaj",
			send: web.current_language_code === 'en' ? "Send" : "Gönder"
		};

		let formHtml = '';
		if (displayForm) {
			formHtml = `
				<div class="no-result-form">
					<div class="row g-2">
						<div class="col-6">
							<input type="text" class="form-control form-control-sm mb-2 mb-lg-0" id="first_name_${messageId}" placeholder="${labels.firstName}" required>
						</div>
						<div class="col-6">
							<input type="text" class="form-control form-control-sm" id="last_name_${messageId}" placeholder="${labels.lastName}" required>
						</div>
						<div class="col-12">
							<input type="email" class="form-control form-control-sm mb-2 mb-lg-0" id="email_${messageId}" placeholder="${labels.email}" required>
						</div>
						<div class="col-12">
							<input type="tel" class="form-control form-control-sm" id="phone_${messageId}" placeholder="${labels.phone}" required>
						</div>
						<div class="col-12">
							<textarea class="form-control form-control-sm" id="content_${messageId}" placeholder="${labels.message}" rows="3" required>${this.escapeHtml(firstSentence)}</textarea>
						</div>
						<div class="col-12 justify-content-start">
							<button type="button" class="btn btn-secondary btn-sm w-100 send-no-result-form" data-message-id="${messageId}">
								${labels.send}
							</button>
						</div>
					</div>
				</div>
			`;
		}

		const messageHtml = `
			<div class="chat-message ai-message" data-message-id="${messageId || ''}">
				<div class="d-flex align-items-end">
					<div class="avatar">
						<i class="icon space-ai"></i>
					</div>
					<div class="message-content">
						<div class="message-bubble">
							<p class="mb-3">${this.escapeHtml(labels.noResults)}</p>
							${formHtml}
						</div>
						<div class="text-muted">${timestamp}</div>
					</div>
				</div>
			</div>
		`;

		messagesContainer.append(messageHtml);

		// Add event listener for the send button only if form is displayed
		if (displayForm) {
			$(document).on('click', `.send-no-result-form[data-message-id="${messageId}"]`, (e) => {
				this.sendNoResultForm(messageId);
			});
		}

		this.scrollToBottom();
	}

	sendNoResultForm(messageId) {
		const firstName = $(`#first_name_${messageId}`).val().trim();
		const lastName = $(`#last_name_${messageId}`).val().trim();
		const email = $(`#email_${messageId}`).val().trim();
		const phone = $(`#phone_${messageId}`).val().trim();
		const content = $(`#content_${messageId}`).val().trim();

		// Multilingual validation messages
		const errorMessages = {
			allFieldsRequired: web.current_language_code === 'en'
				? "Please fill in all fields."
				: "Lütfen tüm alanları doldurunuz.",
			invalidEmail: web.current_language_code === 'en'
				? "Please enter a valid email address."
				: "Geçerli bir e-posta adresi giriniz."
		};

		// Basic validation
		if (!firstName || !lastName || !email || !phone || !content) {
			web.warning_message(errorMessages.allFieldsRequired);
			return;
		}

		if (!this.validateEmail(email)) {
			web.warning_message(errorMessages.invalidEmail);
			return;
		}

		// Prepare form data
		const formData = {
			first_name: firstName,
			last_name: lastName,
			email: email,
			phone: phone,
			content: content,
			message_id: messageId,
			session_id: this.sessionId,
			user_id: this.userId,
			settings: [
				{ key: "criteria", value: "" },
				{ key: "source", value: "web_chat" },
				{ key: "sessionId", value: this.sessionId },
				{ key: "userId", value: this.userId },
			]
		};

		// Disable the button during submission
		const sendButton = $(`.send-no-result-form[data-message-id="${messageId}"]`);
		const submittingText = web.current_language_code === 'en' ? "Sending..." : "Gönderiliyor...";
		sendButton.prop('disabled', true).text(submittingText);

		// Call sendForm function
		this.sendForm(formData, 9);
	}

	async sendForm(data, form_category_id) {
		const token = await grecaptcha.enterprise.execute(web.captcha_key, {
			action: 'LOGIN'
		});
		if (token) {
			data.token = token;
			data.form_category_id = form_category_id;

			web.post("common", { action: "send_form", data: data }, function (result, data) {
				if (result == 1) {
					if (data.id > 0) {
						web.thanks_modal();
					}
				}
			});
		}
	}

	addAISellRentMessage(messageId) {
		const messagesContainer = $('#chat-messages');
		const timestamp = new Date().toLocaleTimeString('tr-TR', {
			hour: '2-digit',
			minute: '2-digit'
		});

		let label = "";
		let link = "";
		if (web.current_language_code == "en") {
			label = "Please click to Sell and Rent";
			link = "https://spaceistanbul.com/en/sell-rent";
		}
		else {
			label = "Satmak ve Kiralamak İçin Tıklayınız";
			link = "https://spaceistanbul.com/tr/sat-kirala";
		}

		const messageHtml = `
			<div class="chat-message ai-message" data-message-id="${messageId || ''}">
				<div class="d-flex align-items-end">
					<div class="avatar">
						<i class="icon space-ai"></i>
					</div>
					<div class="message-content">
						<div class="message-bubble">
							<p>${this.escapeHtml(web.labels.sell_rent_link_info)}</p>
							<div class="mt-1 mb-2">
								<a class="text-underline fw-bold text-primary" href=${link} target="blank">${this.escapeHtml(label)}</a>
							</div>
						</div>
						<div class="text-muted">${timestamp}</div>
					</div>
				</div>
			</div>
		`;

		messagesContainer.append(messageHtml);

		if (scroll) this.scrollToBottom();
	}

	addAIMessage(messageId, responseText, products, allProducts, isEmailSent = false, userEmail = null) {
		const messagesContainer = $('#chat-messages');
		const timestamp = new Date().toLocaleTimeString('tr-TR', {
			hour: '2-digit',
			minute: '2-digit'
		});

		// Generate products HTML if products exist
		let productsHtml = '';
		if (products && products.length > 0) {
			productsHtml = this.generateProductsHtml(products, isEmailSent, userEmail);
		}

		const messageHtml = `
			<div class="chat-message ai-message" data-message-id="${messageId || ''}">
				<div class="d-flex align-items-end">
					<div class="avatar">
						<i class="icon space-ai"></i>
					</div>
					<div class="message-content">
						<div class="message-bubble">
							${responseText ? `<p class="mb-0">${this.escapeHtml(responseText)}</p>` : ''}
							${allProducts && allProducts.length > 0 ? `<p class="mt-1 mb-1 fw-bold">${web.labels.found_product_count}: ${allProducts.length}</p>` : ''}
							${productsHtml}
						</div>
						<div class="text-muted">${timestamp}</div>
					</div>
				</div>
			</div>
		`;

		messagesContainer.append(messageHtml);

		if (scroll) this.scrollToBottom();
	}

	generateProductsHtml(products, isEmailSent = false, userEmail = null) {
		if (!products || products.length === 0) return '';

		let productsHtml = '<div class="product-results mt-2">';
		productsHtml += '<div class="product-list">';

		products.forEach(product => {
			let image_src = "/assets/image/product.png";
			if (product.image) {
				image_src = web.media_server + product.image;
			}
			let price = this.formatPrice(product.price, product.is_price_hidden);
			let area = this.formatArea(product.gross_area, product.net_area);
			let product_link = "";
			if (web.current_language_code == "tr") {
				product_link = "/tr/portfoy/-/-/" + product.id;
			}
			else {
				product_link = "/en/property/-/-/" + product.id;
			}

			productsHtml += `
				<div class="product" onclick="window.open('${product_link}', '_blank')">
					<div class="title">${this.escapeHtml(product.title.toUpperCase() || '')}</div>
					<div class="d-flex align-items-start">
						<div class='image-container'>
							<img src="${image_src}" class="image">
						</div>
						<div class="content-container">
							<div class="reference-no">${product.id || ''}</div>
							<div class="price">${this.escapeHtml(price)}</div>
						</div>
					</div>
					<div class='content-line mt-2'>
						<div class="content-line-text">${this.escapeHtml(product.transaction_type || '')}</div>
						<i class="icon dot gray ms-1 me-1"></i>
						<div class="content-line-text">${this.escapeHtml(product.product_sub_group || '')}</div>
						<i class="icon dot gray ms-1 me-1"></i>
						<div class="content-line-text">${this.escapeHtml(product.quarter || '')}, ${this.escapeHtml(product.town || '')}</div>
					</div>
					<div class='content-line'>
						<div class="content-line-text">
							<i class="icon area"></i>
							<div>${this.escapeHtml(area) || ''}</div>
						</div>
						<div class="content-line-text">
							<i class="icon room"></i>
							<div>${this.escapeHtml(product.room_type || '')}${this.escapeHtml(product.commercial_room_type || '')}</div>
						</div>
						<div class="content-line-text">
							<i class="icon bathroom"></i>
							<div>${this.escapeHtml(product.num_of_bathroom || '')}</div>
						</div>
					</div>
				</div>
			`;
		});

		// Add email section at the end of product list
		// Use message-specific email if provided, otherwise fall back to session email
		const emailValue = userEmail || this.userEmail || '';
		productsHtml += `
			<div class="w-100 mt-3">
				<div class="send-email-input-group input-group input-group-sm">
					<input type="email" class="user-email-input form-control flex-fill" placeholder="${web.labels.ai_chat_email_info}" value="${emailValue}">
					<button class="send-email-button btn btn-primary" type="button">
						<i class="icon email white me-1"></i>
						${web.labels.do_send_email}	
					</button>
				</div>
		`;

		// Show information if email was previously sent
		if (isEmailSent) {
			productsHtml += `
				<div class="p-2 mt-2 d-flex justify-content-start align-items-center">
					<i class="icon dot orange"></i>
					<div class="fs-8">${web.labels.has_already_been_emailed}</div>
				</div>
			`;
		}

		productsHtml += `</div>`;

		productsHtml += '</div></div>';
		return productsHtml;
	}

	addUserMessage(messageId, message, scroll = true) {
		const messagesContainer = $('#chat-messages');
		const timestamp = new Date().toLocaleTimeString('tr-TR', {
			hour: '2-digit',
			minute: '2-digit'
		});

		const messageHtml = `
			<div class="chat-message user-message" data-message-id="${messageId || ''}">
				<div class="d-flex align-items-start justify-content-end">
					<div class="message-content text-end">
						<div class="message-bubble">
							<div>${this.escapeHtml(message)}</div>
						</div>
						<div class="text-muted">${timestamp}</div>
					</div>
				</div>
			</div>
		`;

		messagesContainer.append(messageHtml);
		if (scroll) this.scrollToBottom();
	}

	async sendEmail(event) {
		const clickedBtn = $(event.target).closest('.send-email-button');
		const messageContainer = clickedBtn.closest('.chat-message');
		const messageId = messageContainer.data('message-id');
		const emailInput = messageContainer.find('#user-email, .user-email-input');
		const email = emailInput.val().trim();

		// Get products from the specific message
		const messageProducts = this.getMessageProducts(messageContainer);

		if (!email || !this.validateEmail(email)) {
			web.warning_message(web.labels.err_invalid_email);
			return;
		}

		clickedBtn.prop('disabled', true);

		try {
			const productIds = messageProducts.map(p => p.id);

			const updateResponse = await fetch('/functions/n8n.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action: 'update_message_email',
					email: email,
					message_id: messageId,
					session_id: this.sessionId,
					user_id: this.userId
				})
			});

			const updateResult = await updateResponse.json();

			if (!updateResult.success) {
				web.error_message();
				return;
			}

			// Then send the email
			const response = await fetch('/functions/n8n.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action: 'email_product_search_chat_products',
					email: email,
					text: 'AI asistanımız size bu ürünleri önerdi:',
					products: productIds,
					message_id: messageId,
					session_id: this.sessionId,
					user_id: this.userId
				})
			});

			const result = await response.json();

			if (result.success) {
				// Store user email for future use in this session
				this.userEmail = email;

				web.success_message();

				// Update or add the info message about email being sent
				const emailSection = messageContainer.find('#email-section');
				let infoAlert = emailSection.find('.alert-info');

				if (infoAlert.length === 0) {
					// Add new info alert if it doesn't exist
					emailSection.append(`
						<div class="alert alert-info alert-sm p-2 mt-2 mb-0">
							<i class="icon info-circle me-1"></i>
							Bu ürün listesi daha önce e-posta ile gönderildi
						</div>
					`);
				}

				// Clear the email input after successful send
				emailInput.val('');
			} else {
				web.error_message();
			}
		} catch (error) {
			console.error('Email send error:', error);
			web.error_message();
		} finally {
			clickedBtn.prop('disabled', false);
		}
	}

	setLoading(loading) {
		this.isLoading = loading;
		const sendBtn = $('#send-btn');
		const chatInput = $('#chat-input');

		if (loading) {
			sendBtn.prop('disabled', true);
			chatInput.prop('disabled', true);
			this.addLoadingMessage();
		} else {
			sendBtn.prop('disabled', false);
			chatInput.prop('disabled', false);
			this.removeLoadingMessage();
			chatInput.focus();
		}
	}

	new_session_id() {
		return "web_chat" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
	};

	startNewChat() {
		// Clear all messages
		$('#chat-messages').empty();

		// Create new session ID
		this.sessionId = this.new_session_id();

		// Reset other session-related properties
		this.currentProducts = [];
		this.userEmail = null;

		// Clear input
		$('#chat-input').val('');
		$('#char-counter').text('0/500').removeClass('text-danger');

		// Focus on input
		$('#chat-input').focus();
	}

	openSidenav() {
		const sidenav = $('#ai-chat-sidenav');
		const overlay = $('#ai-chat-overlay');

		sidenav.addClass('open')
			.css({
				'right': '0px',
				'position': 'fixed',
				'top': '0',
				'z-index': '9999',
				'width': '400px',
				'height': '100vh'
			});

		overlay.addClass('show');
		$('body').addClass('chat-open');

		setTimeout(() => {
			this.loadChatHistory();
			$('#chat-input').focus();
		}, 300);
	}

	closeSidenav() {
		const sidenav = $('#ai-chat-sidenav');
		const overlay = $('#ai-chat-overlay');
		const chatInput = $('#chat-input');

		sidenav.removeClass('open').css('right', '-400px');
		overlay.removeClass('show');
		$('body').removeClass('chat-open');

		chatInput.val('');
	}

	scrollToBottom() {
		const messagesContainer = $('#chat-messages')[0];
		setTimeout(() => {
			messagesContainer.scrollTop = messagesContainer.scrollHeight;
		}, 100);
	}

	validateEmail(email) {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	}

	escapeHtml(text) {
		const div = document.createElement('div');
		div.textContent = text;
		return div.innerHTML;
	}

	formatPrice(price, is_hidden = 0) {
		if (!price) return '';

		if (is_hidden == 1) return ' ₺ İletişime Geçiniz';

		const formatted_price = new Intl.NumberFormat('tr-TR', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(price);
		return ' ₺ ' + formatted_price;
	}

	formatArea(grossArea, netArea) {
		if (!grossArea && !netArea) return ' - / -';
		let gross = Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(grossArea)
		let net = Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(netArea)
		return gross + ' / ' + net + " m²";
	}

	getMessageProducts(messageContainer) {
		// Extract product information from the message container
		// This is a fallback method to get products from DOM when they're not in memory
		const products = [];
		const productElements = messageContainer.find('.product');

		productElements.each((index, element) => {
			const $product = $(element);
			const referenceNo = $product.find('.reference-no').text().trim();
			if (referenceNo) {
				products.push({ id: parseInt(referenceNo) });
			}
		});

		// If this is the current message, use currentProducts for full data
		const messageId = messageContainer.data('message-id');
		if (this.currentProducts.length > 0) {
			return this.currentProducts;
		}

		return products;
	}
}
